import CityPageTemplate from "../hawaii-city/CityPageTemplate";
import { waikikiConfig } from "./data";

export default function Page() {
  return <CityPageTemplate config={waikikiConfig} />;
}